import type { TextFieldProps } from '@mui/material';

import { useBoolean } from 'minimal-shared/hooks';

import { Tooltip, IconButton, InputAdornment } from '@mui/material';

import { useTranslate } from 'src/locales';

import { Iconify } from 'src/components/iconify';
import { Field } from 'src/components/hook-form';

type PasswordFieldProps = TextFieldProps & {
  name: string;
  label: string;
};

export function PasswordField({ name, label, ...other }: PasswordFieldProps) {
  const { t } = useTranslate('translation');
  const showPassword = useBoolean();

  return (
    <Field.Text
      name={name}
      label={label}
      type={showPassword.value ? 'text' : 'password'}
      autoComplete="off"
      slotProps={{
        input: {
          inputProps: { autoComplete: 'new-password' },
          startAdornment: <Iconify icon="solar:lock-bold" width={20} sx={{ mr: 1 }} />,
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title={showPassword.value ? t('HIDE_PASSWORD') : t('SHOW_PASSWORD')}>
                <IconButton onClick={showPassword.onToggle} edge="end">
                  <Iconify icon={showPassword.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        },
        inputLabel: { shrink: true },
        htmlInput: { autoComplete: 'off' },
      }}
      {...other}
    />
  );
}
